export const FILE_COUNT_LIMIT = 10;

export const FILE_SIZE_LIMIT = 5; // in MB
